export default __webpack_public_path__ + "static/media/songUserDefault.596b883b.svg";